export const CategoryFragment = /* GraphQL */ `
	fragment CategoryFragment on Category {
		_id
		created_at
		updated_at
		title
		title_localized {
			cn
			kh
		}
		is_template
		clone_from
		ordering_index
		_qr_items_count
		availability {
			days
			times {
				from
				to
			}
		}
	}
`;
